module.exports = __webpack_public_path__ + "img/menu-jixiao.c4e367fe.svg";